var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72081 10.0343C9.15182 9.60331 9.85062 9.60331 10.2816 10.0343L14.9641 14.7168C15.3951 15.1478 15.3951 15.8466 14.9641 16.2776C14.5331 16.7086 13.8343 16.7086 13.4033 16.2776L8.72081 11.5951C8.2898 11.1641 8.2898 10.4653 8.72081 10.0343V10.0343Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4667 16.2775C13.0357 15.8465 13.0357 15.1477 13.4667 14.7167L18.1491 10.0342C18.5802 9.60319 19.279 9.60319 19.71 10.0342C20.141 10.4652 20.141 11.164 19.71 11.595L15.0275 16.2775C14.5965 16.7085 13.8977 16.7085 13.4667 16.2775V16.2775Z",
    fill: "#383838"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.c3b441315959637304b2e155cd914f77.svg";
export { ForwardRef as ReactComponent };